import { useRef } from 'react';

import HorizontalScroll from '@/components/HorizontalScroll';
import { useIssueRemarksMutation } from '@/features/my-dashborad/api/myDashboardApi';
import { toastError, toastSuccess } from '@/components/Toast';

const IssueListView = ({
	listViewResponse,
	handleSelectSampleItem,
	handleSelectAllSampleItem,
	onClickDesignImage,
	selectedSampleItem
}) => {
	const elementRef = useRef(null);
	const [issueRemarks, { isLoading: isUpdatingIssueRemarks }] = useIssueRemarksMutation();

	const handleGetRemarks = async (item, remarks) => {
		try {
			await issueRemarks({ id: item?.productIssueResponse?.id, remarks }).unwrap();
			toastSuccess('Remarks updated successfully');
		} catch ({ error }) {
			toastError(error?.data?.message || 'Something went wrong');
		}
	};

	const issueStatusBadgeStyle = (status) => {
		const s = String(status ?? '')
			.trim()
			.toLocaleLowerCase();
		switch (s) {
			case 'cancel':
				return { background: 'rgb(255, 218, 218)' };
			case 'solved':
				return { background: 'rgb(219, 255, 229)' };
			case 'pending':
				return { background: 'rgb(218, 232, 255)' };
			default:
				return { background: 'rgb(219, 255, 229)' };
		}
		return { background: 'rgb(219, 255, 229)' };
	};
	const renderIssueListViewRow = (item, idx) => {
		const issueResponse = item?.productIssueResponse;
		return (
			<tr key={`${item.id}_${idx}`}>
				<td className="select-box-column">
					<div className="custom-chekbox">
						<div className="form-group m-0">
							<input
								type="checkbox"
								id={`${item?.id}-${idx}`}
								name={`sample_${item?.id}`}
								value={item?.id}
								onChange={(e) => handleSelectSampleItem(e, item)}
								checked={selectedSampleItem.includes(parseInt(item?.id))}
							/>
							<label htmlFor={`${item?.id}-${idx}`} />
						</div>
					</div>
				</td>
				<td
					className={`image-column cursor-pointer ${issueResponse?.isSameProduct ? 'd-none' : ''}`}
					rowSpan={issueResponse?.noOfSameProduct || 1}
					onClick={() => onClickDesignImage(item?.id)}
				>
					<div className="d-flex align-items-center justify-content-center">
						<img src={item.designDocuments?.[0]?.docUrl} alt="" className="cell-img pr-2" />
					</div>
				</td>
				<td
					className={`style-details-column ${issueResponse?.isSameProduct ? 'd-none' : ''}`}
					rowSpan={issueResponse?.noOfSameProduct || 1}
				>
					<p className="semibold-14 gray_dark_02">{item?.systemReferenceNumber}</p>
					<p className="regular-14 gray_dark_02 mb-0">{item?.productGroup}</p>
					<p className="regular-14 gray_dark_02 mb-0">{item?.mainFabricType}</p>
				</td>
				<td
					className={`body-fabric-column ${issueResponse?.isSameProduct ? 'd-none' : ''}`}
					rowSpan={issueResponse?.noOfSameProduct || 1}
				>
					<p className="regular-14 gray_dark_02 mb-0">{item?.fabricDetails}</p>
				</td>
				<td
					className={`print-embo-column ${issueResponse?.isSameProduct ? 'd-none' : ''}`}
					rowSpan={issueResponse?.noOfSameProduct || 1}
				>
					<p className="regular-14 gray_dark_02 mb-0">
						Print:
						{item?.printCategoryList?.map((item) => item?.name).join(', ')}
					</p>
					<p className="regular-14 gray_dark_02 mb-0">
						Embo:
						{item?.embroideryCategoryList?.map((item) => item?.name).join(', ')}
					</p>
				</td>
				<td
					className={`wash-column ${issueResponse?.isSameProduct ? 'd-none' : ''}`}
					rowSpan={issueResponse?.noOfSameProduct || 1}
				>
					<p className="regular-14 gray_dark_02 mb-0">
						{item?.washCategoryList?.map((item) => item?.name).join(', ')}
					</p>
				</td>
				<td
					className={`last-status-column ${issueResponse?.isSameProduct ? 'd-none' : ''}`}
					rowSpan={issueResponse?.noOfSameProduct || 1}
				>
					<>
						{item?.productStatusList?.map((sts) => (
							<>
								<span className="status yellow-1 status-with-border d-inline-block mb-1">
									{sts?.status}
								</span>
								<p className="regular-12 gray_dark_02 mb-0">{sts?.date}</p>
							</>
						))}
						{Array.isArray(item?.lastTaskCreatedBy) ? (
							item?.lastTaskCreatedBy?.map((nme) => (
								<p className="regular-14 gray_dark_02 mb-0">{nme?.nickName}</p>
							))
						) : (
							<p className="regular-14 gray_dark_02 mb-0">
								{item?.lastTaskCreatedBy?.nickName}
							</p>
						)}
					</>
				</td>
				<td className="issue-status-column">
					<span className="status radius" style={issueStatusBadgeStyle(issueResponse?.status)}>
						{issueResponse?.status}
					</span>
				</td>
				<td className="issue-raise-by-column">
					<p className="regular-14 gray_dark_02 mb-0">{issueResponse?.createdBy?.nickName}</p>
				</td>
				<td className="issue-type-column">
					<p className="regular-14 gray_dark_02 mb-0">{issueResponse?.issueTypeList?.join(', ')}</p>
				</td>
				<td className="issue-details-column">
					<p className="regular-14 gray_dark_02 mb-0">{issueResponse?.details}</p>
				</td>
				<td className="issue-who-solve-column">
					{issueResponse?.responsibleUsersList?.map((item) => (
						<p className="regular-14 gray_dark_02 mb-0">{item?.nickName},</p>
					))}
				</td>
				<td className="issue-notify-column">
					{issueResponse?.notifyUsersList?.map((item) => (
						<p className="regular-14 gray_dark_02 mb-0">{item?.nickName},</p>
					))}
				</td>
				<td className="issue-hold-column">
					<p className="regular-14 gray_dark_02 mb-0">
						{issueResponse?.holdDevelopment ? 'Yes' : 'No'}
					</p>
				</td>
				<td className="issue-sample-correction-column">
					<p className="regular-14 gray_dark_02 mb-0">{issueResponse?.rework ? 'Yes' : 'No'}</p>
				</td>
				<td className="remarks-textfield-column text-field-column">
					<input
						type="text"
						placeholder="Remarks"
						defaultValue={item?.issueResponse?.remarks ?? ''}
						onBlur={(e) => handleGetRemarks(item, e.target.value)}
						onKeyDown={(e) => {
							if (e.key === 'Enter') e.currentTarget.blur();
						}}
						disabled={isUpdatingIssueRemarks}
					/>
				</td>
			</tr>
		);
	};
	return (
		<div>
			<div className="list-view-table-container mt-4 mb-4">
				<HorizontalScroll elementReference={elementRef.current} />
				<div className="costing-details-view-table scroll-x-label" ref={elementRef}>
					<table className="table with-border ">
						<thead>
							<tr>
								<th className="select-box-column">
									<div className="custom-chekbox">
										<div className="form-group m-0">
											<input
												type="checkbox"
												id="selectAll"
												name="selectAll"
												onChange={(e) => handleSelectAllSampleItem(e)}
												checked={listViewResponse?.data?.every((item) =>
													selectedSampleItem.includes(parseInt(item?.id))
												)}
											/>
											<label htmlFor="selectAll" />
										</div>
									</div>
								</th>
								<th>Image</th>
								<th>Style details</th>
								<th>Body fabric</th>
								<th>Print, Embo</th>
								<th>Wash</th>
								<th className="white-space-nowrap">Style last status</th>
								<th>Issue status</th>
								<th>Issue raise by</th>
								<th>Issue type</th>
								<th>Details</th>
								<th>Who will solve?</th>
								<th>Notify to</th>
								<th>Hold TP</th>
								<th className="white-space-nowrap">Sample correction needed?</th>
								<th>Remarks</th>
							</tr>
						</thead>
						<tbody>
							{listViewResponse?.map((item, idx) => renderIssueListViewRow(item, idx))}
						</tbody>
					</table>
				</div>
			</div>
		</div>
	);
};

export default IssueListView;
